import { useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userLoginThunk } from "../modules/userReducer";
import Login from "../pages/Login";
import useLoginCheck from "../hooks/useLoginCheck";

const LoginContainer = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector((state) => state.user);

  useLoginCheck(dispatch);

  const handleLogin = useCallback(() => {
    dispatch(userLoginThunk());
  }, [dispatch]);

  useEffect(() => {
    if (user.loggedIn) history.push("/maker");
  }, [history, user]);

  return !user.loggedIn && <Login onLogin={handleLogin} />;
};

export default LoginContainer;
